import moment from "moment/moment";
import List from "../../../Components/List";
import React from "react";
import FlexRow from "../../../Components/FlexRow";
import {StyledText} from "../../../Components/Text";
import Box from "Components/Box";
import {useTranslation} from "react-i18next";
import {useAuthorizations} from "../../../Apis/Admin/AuthorizationApi";
import {EloverblikAuthorizationModel} from "../../../Apis/Models/EloverblikAuthorizationModel";
import Gap from "../../../Components/Gap";
import Button from "../../../Components/Button";
import {useNavigate} from "react-router";

const AuthorizationsPage = () => {

    const { t } = useTranslation();
    
    const { data: authorizations, isLoading } = useAuthorizations();
    
    const navigate = useNavigate();
    
    const getColor = (authorization: EloverblikAuthorizationModel) => {
        if (authorization.status === 'Active') {
            if (moment(authorization.validTo).add(-1, 'month').isAfter(moment())) {
                return "#18A957"
            } else {
                return "#FDD343";
            }
        }
        
        return "#FB5151";
    }
    
    return (
        <Box>
            <FlexRow justify={"space-between"} align={"center"} style={{paddingBottom: 30}}>
                <StyledText type={"Lead"} weight={"Bold"} color={"secondary"}>{t('authorizations')}</StyledText>
            </FlexRow>
            <List data={authorizations ?? []} loading={isLoading} columns={[
                {
                    dataIndex: 'status',
                    title: t('status'),
                    customRender: (_, record) => (
                        <Gap size={"small"}>
                            <div style={{borderRadius: 20, width: 20, height: 20, backgroundColor: getColor(record)}}></div>
                            {record.status}
                        </Gap>
                    )
                },
                {
                    dataIndex: 'externalId',
                    title: t('agreementExternalId'),
                },
                {
                    dataIndex: 'customerKey',
                    title: t('customerKey'),
                },
                {
                    dataIndex: 'customerCVR',
                    title: t('vatNumber'),
                },
                {
                    dataIndex: 'customerName',
                    title: t('customerName'),
                },
                {
                    dataIndex: 'externalId',
                    title: t('period'),
                    customRender: (_, record) => (
                        <div>{moment(record.validFrom).format('DD-MM-yyyy')} - {moment(record.validTo).format('DD-MM-yyyy')}</div>
                    )
                },
                {
                    dataIndex: 'externalId',
                    title: t('expiresIn'),
                    customRender: (_, record) => (
                        <div>{moment(record.validTo).diff(moment(), 'days')} {t('days')}</div>
                    )
                },
                {
                    dataIndex: 'expiresSoonMailSent',
                    title: t('ExpiresSoonMailSent'),
                    customRender: (value) => (
                        <div>{value ? moment(value).format('DD-MM-yyyy HH:mm:ss') : t('no')}</div>
                    )
                },
                {
                    dataIndex: 'externalId',
                    title: t('functions'),
                    customRender: (value, record: EloverblikAuthorizationModel) => (
                        <>
                            {!!record.agreementId && (
                                <Button color={"link"} onClick={() => navigate(`/admin/agreements/${record.agreementId}`)} text={t('gotoAgreement')} />            
                            )}
                        </>
                    )
                },
            ]} emptyText={t('noAuthorizationsFound')} keyDataIndex={"id"}
            />
        </Box>
    )

}

export default AuthorizationsPage